"use client";

import { Check } from "lucide-react";

import { SCHEDULING_STEPS, STEP_LABELS, type SchedulingStepId } from "@/src/components/online-scheduling/types";
import { cn } from "@/src/lib/shadcn-utils";

export function ProgressSteps({ current }: { current: SchedulingStepId }) {
  const currentIndex = SCHEDULING_STEPS.indexOf(current);

  return (
    <nav aria-label="Progress" className="w-full">
      {/* Compact label for small screens */}
      <p className="mb-4 text-center text-sm font-medium text-muted-foreground sm:hidden">
        Step {currentIndex + 1} of {SCHEDULING_STEPS.length} &middot; {STEP_LABELS[current]}
      </p>

      <ol className="hidden items-center sm:flex">
        {SCHEDULING_STEPS.map((step, index) => {
          const isComplete = index < currentIndex;
          const isCurrent = index === currentIndex;

          return (
            <li key={step} className={cn("flex items-center", index < SCHEDULING_STEPS.length - 1 && "flex-1")}>
              <div className="flex items-center gap-2">
                <span
                  className={cn(
                    "flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition-colors",
                    isComplete && "border-foreground bg-foreground text-background",
                    isCurrent && "border-foreground text-foreground",
                    !isComplete && !isCurrent && "border-border text-muted-foreground"
                  )}
                >
                  {isComplete ? <Check className="h-4 w-4" /> : index + 1}
                </span>
                <span
                  className={cn(
                    "whitespace-nowrap text-sm",
                    isCurrent ? "font-semibold text-foreground" : "text-muted-foreground"
                  )}
                >
                  {STEP_LABELS[step]}
                </span>
              </div>

              {index < SCHEDULING_STEPS.length - 1 && (
                <div className={cn("mx-2 h-px flex-1", isComplete ? "bg-foreground" : "bg-border")} />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
